<ion-toolbar>
    <ion-buttons slot="start">
        <ion-button (click)="cancelPurchaseOrder()">
            <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
        </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
        <ion-button (click)="addItem()">
            <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
        <ion-button (click)="scanItem()">
            <ion-icon slot="icon-only" name="barcode"></ion-icon>
        </ion-button>
    </ion-buttons>
    <ion-searchbar animated debounce="300" [(ngModel)]="queryText">
    </ion-searchbar>
</ion-toolbar>

<ion-content>
    <ion-list>
        <ion-item *ngIf="documentTemp.detailLines.length <= 0" lines="none">
            <ion-label>Tap the plus or scan barcode button to add an Item</ion-label>
        </ion-item>
        <ion-item-sliding *ngFor="let line of documentTemp.detailLines; index as i;" (click)="editQty(line)">
            <ion-item>
                <ion-label class="ion-text-wrap">
                    {{line.qty + ' of ' + line.description}}
                </ion-label>
            </ion-item>
            <ion-item-options side="start">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button color="danger" (click)="documentTemp.detailLines.splice(i, 1)">
                        <ion-icon name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>
        </ion-item-sliding>
    </ion-list>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button color="success" (click)="savePurchaseOrder()">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
